import { createSelector } from "@ngrx/store";
import { getBankAccountState } from "./appState";

export interface BankAccountState {
  list: {
    data: Array<any>;
    loading: boolean;
    error: boolean;
  };
  assets: {
    data: Array<any>;
  };
  balance: {
    amount: number;
    loading: boolean;
    error: boolean;
  };
  transactions: {
    data: Array<any>;
    loading: boolean;
    error: boolean;
  };
  send: {
    data: {
      amount: string;
      address: string;
      token: string;
    };
    loading: boolean;
    error: boolean;
  };
  readonly bankingHistory: {
    pageNumber: number,
    pageSize: number,
    loadedAll: boolean,
    data: any[]
  };
  plaidLinkToken: string | boolean;
}

export const getBankAccountList = createSelector(getBankAccountState, (state) => state.list);

export const getBankAccountBalance = createSelector(getBankAccountState, (state) => state.balance);

export const getBankAccountTransactionList = createSelector(getBankAccountState, (state) => state.transactions);

export const getBankAssetsList = createSelector(
  getBankAccountState,
  (state) => state.assets.data
);

export const getBankingHistory = createSelector(
  getBankAccountState,
  (state: BankAccountState) => state.bankingHistory.data
);

export const getBankingHistoryLoadedState = createSelector(
  getBankAccountState,
  (state: BankAccountState) => state.bankingHistory.loadedAll
);

export const getBankAccountPlaidLinkToken = createSelector(
  getBankAccountState,
  (state) => state.plaidLinkToken
);
